import { openModal, closeModal } from './store/modal-actions';
import { modal } from './store/reducer';
import { NAME } from './store/modal-state-name';

export { createModalOpenedMiddleware } from './store/modal-opened-middleware';
export { createModalClosedMiddleware } from './store/modal-closed-middleware';

export const modalActions = {
  openModal,
  closeModal,
};

export const modalReducer = (...args) => ({ [NAME]: modal(...args) });
